import React, { useEffect, useState, useContext } from "react";
import "./resume.css";
import ThemeContext from "../../context/ThemeContext";
import ExperienceHistory from "../experience/experience-history";
import { onNodeVisible } from "../../utils/elementUtils";
import { wait } from "../../utils/genericUtils";

function Resume(props) {
  const { theme } = useContext(ThemeContext);
  const [sk1, setSk1] = useState(false);

  useEffect(() => {
    // Schedule observers after paint
    setTimeout(() => {
      document.querySelectorAll('#resume .animate-on-scroll').forEach((el) => {
        onNodeVisible(el, () => {
          el.classList.add('in-view');
        }, 0.1);
      });

      let skillsSection = document.querySelector("#Skills");
      if (skillsSection) {
        onNodeVisible(skillsSection, () => {
          SkillsAnimation();
        }, 0.1);
      }
      setNavResume();
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setAllInactive() {
    document.querySelectorAll("a.active").forEach((link) => {
      link.classList.remove("active");
    });
  }

  function setNavResume() {
    let header = document.querySelector("#resume");
    if (header) {
      onNodeVisible(
        header,
        () => {
          setAllInactive();
          document.querySelector("#experience-link")?.classList.add("active");
          document.querySelector("#experience-link-mobile")?.classList.add("active");
        },
        window.innerWidth > 750 ? 0.4 : 0.1
      );
    }
  }

  async function SkillsAnimation() {
    await wait(800);
    setSk1(true);
  }

  return (
    <section id="resume">
      <div className="resume-sections-container">

        {/* Left Column: Experience */}
        <div className="resume-experiences">
          <section id="Experience" className="resume-section">
            <h2 className="resume-section-header animate-on-scroll">Experience</h2>
            <div className="animate-on-scroll" style={{ width: '100%' }}>
              <ExperienceHistory
                id={"exp-0"}
                header={"Founder"}
                subHeader={"FileFreak LLC"}
                details={[
                  `Architecting and engineering the FileFreak.io platform, an ambitious secure cloud-storage application with a modern React frontend and globally distributed Node.js/AWS backend.`
                ]}
                start={"2025"}
                end={"Present"}
              />
            </div>

            <div className="animate-on-scroll" style={{ width: '100%' }}>
              <ExperienceHistory
                id={"exp-2"}
                header={"Senior Software Engineer"}
                subHeader={"Prudential Financial"}
                details={[
                  `Architecting and developing modern, responsive web applications integrating AI-driven insights to enhance customer experience.`,
                  `Collaborating with cross-functional teams to modernize legacy systems, migrate cloud infrastructure, and establish robust CI/CD pipelines.`
                ]}
                start={"2023"}
                end={"Present"}
              />
            </div>

            <div className="animate-on-scroll" style={{ width: '100%' }}>
              <ExperienceHistory
                id={"exp-3"}
                header={"Software Engineer II"}
                subHeader={"Seisan Consulting"}
                details={[
                  `Technical lead on an ambitious mobile application currently available on the App Store and Google Play with over 6,000 downloads, 300 DAU, and growing.`,
                  `Building and deploying highly available and scalable REST APIs hosted in AWS and Azure Cloud services. One of these APIs averages around 32,000 requests per day and is still growing.`,
                  `Collaborating with project managers, stakeholders, and developers to efficiently scope tasks, delegate work, and engineer software solutions.`
                ]}
                start={"2022"}
                end={"2023"}
              />
            </div>

            <div className="animate-on-scroll" style={{ width: '100%' }}>
              <ExperienceHistory
                id={"exp-4"}
                header={"Software Engineer"}
                subHeader={"Seisan Consulting"}
                details={[
                  `Specializing in full-stack software engineering for .NET & NodeJs web development, mobile, and game development, including AR and VR experiences.`,
                  `Devising solutions to optimize app bundle sizes to comply with Google Play standards.`,
                  `Leading the development of an ambitious WebXR art gallery project. Oversaw the architecture of a React user interface, a Node.js backend hosted on an AWS EC2 instance, and a WebGL gallery editor/viewer hosted in S3.`
                ]}
                start={"2021"}
                end={"2022"}
              />
            </div>

            <div className="animate-on-scroll" style={{ width: '100%' }}>
              <ExperienceHistory
                id={"exp-5"}
                header={"Computer Science Intern"}
                subHeader={"Seisan Consulting"}
                details={[
                  `Gained hands-on experience with full-stack development in a fast-paced environment.`,
                  `Quickly acquiring proficiency in a multitude of different tech stacks for client applications.`
                ]}
                start={"2021"}
                end={"2021"}
              />
            </div>
          </section>
        </div>

        {/* Right Column: Education and Skills */}
        <section className="resume-right">
          <section id="Education" className="resume-section">
            <h2 className="resume-section-header animate-on-scroll">Education</h2>
            <div className="animate-on-scroll" style={{ width: '100%' }}>
              <ExperienceHistory
                id={"exp-1"}
                header={"Pennsylvania State University"}
                subHeader={"Bachelors of Science, Information Sciences & Technology"}
                details={["3.4 GPA", "Deans List"]}
                start={"2018"}
                end={"2022"}
              />
            </div>
          </section>

          <section id="Skills" className="resume-section">
            <h2 className="resume-section-header animate-on-scroll">Technical Skills</h2>
            <div className={`skills-pills-container ${sk1 ? 'show' : ''}`}>
              <span className={`skill-pill ${theme === 'light' ? 'light' : ''}`}>React & Next.js</span>
              <span className={`skill-pill ${theme === 'light' ? 'light' : ''}`}>React Native</span>
              <span className={`skill-pill ${theme === 'light' ? 'light' : ''}`}>TypeScript</span>
              <span className={`skill-pill ${theme === 'light' ? 'light' : ''}`}>Node.js & Express</span>
              <span className={`skill-pill ${theme === 'light' ? 'light' : ''}`}>AWS / Azure / GCP</span>
              <span className={`skill-pill ${theme === 'light' ? 'light' : ''}`}>Python & AI Integrations</span>
              <span className={`skill-pill ${theme === 'light' ? 'light' : ''}`}>Unity & Unreal Engine</span>
              <span className={`skill-pill ${theme === 'light' ? 'light' : ''}`}>UI/UX Design</span>
              <span className={`skill-pill ${theme === 'light' ? 'light' : ''}`}>Docker & CI/CD</span>
              <span className={`skill-pill ${theme === 'light' ? 'light' : ''}`}>System Architecture</span>
            </div>
          </section>
        </section>

      </div>
    </section>
  );
}

export default Resume;
